var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42694 4.68848L9.84013 1.25M9.84013 1.25L13.2533 4.68848M9.84013 1.25V12.7116M4.15174 9.27311C3.09151 9.27311 2.56139 9.27311 2.14322 9.44756C1.58567 9.68023 1.14244 10.1268 0.911489 10.6885C0.738281 11.1097 0.738281 11.6435 0.738281 12.7116V18.2132C0.738281 19.497 0.738281 20.1385 0.986295 20.6288C1.20444 21.0601 1.55229 21.4115 1.98046 21.6312C2.46672 21.8809 3.10361 21.8809 4.37551 21.8809H15.3053C16.5772 21.8809 17.2132 21.8809 17.6995 21.6312C18.1276 21.4115 18.4761 21.0601 18.6942 20.6288C18.942 20.1389 18.942 19.498 18.942 18.2167V12.7116C18.942 11.6435 18.9419 11.1097 18.7687 10.6885C18.5377 10.1268 18.0948 9.68023 17.5373 9.44756C17.1191 9.27311 16.589 9.27311 15.5288 9.27311",
    stroke: "#00092C",
    strokeWidth: 1.4563,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/Share_icon.be3b96da97e4aa3efc5a3d5e442f0747.svg";
export { ForwardRef as ReactComponent };